
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 13a1 1 0 110-2 1 1 0 010 2zm-3-1a3 3 0 106 0 3 3 0 00-6 0zM12 13a1 1 0 110-2 1 1 0 010 2zm-3-1a3 3 0 106 0 3 3 0 00-6 0zM4 13a1 1 0 110-2 1 1 0 010 2zm-3-1a3 3 0 106 0 3 3 0 00-6 0z","fill":"#111"}})])
          )
        }
      }
    